
	frappe.templates['contact_list'] = `{% if (contact_list.length) { %}
	<div class="card-list-actions">
		{%= frappe.ui.button.html({ label: __("Contact"), icon: "plus", size: "sm", css_class: "btn-contact" }) %}
	</div>
{% } %}

<div class="clearfix"></div>
{% for (const contact of contact_list) { %}
	<div class="contact-box" data-name="{%= frappe.utils.escape_html(contact.name) %}">
		{%= frappe.ui.button.html({ icon: "ellipsis", variant: "ghost", size: "sm", title: __("Options"), css_class: "card-menu-btn" }) %}
		<div class="box-header flex items-center flex-wrap gap-2">
			<span class="text-base-semibold text-ink-gray-8">{%= frappe.utils.escape_html(contact.first_name) %} {%= frappe.utils.escape_html(contact.last_name) %}</span>
			{% if (contact.name === primary_name) { %}
				{%= frappe.ui.badge.html({ label: __("Primary"), size: "sm" }) %}
			{% } %}
		</div>
		{% if (contact.is_billing_contact) { %}
			<div class="box-subtitle text-sm text-ink-gray-5">{%= __("Billing") %}</div>
		{% } %}
		{% let mobile_no = contact.mobile_no !== contact.phone ? contact.mobile_no : ""; %}
		{% if (contact.designation) { %}
			<div class="contact-line flex items-center gap-2 text-ink-gray-7" title="{%= __("Designation") %}">
				{%= frappe.utils.icon("briefcase", "sm", "", "", "text-ink-gray-5", true) %}
				<span>{%= frappe.utils.escape_html(contact.designation) %}</span>
			</div>
		{% } %}
		{% if (contact.phone) { %}
			<div class="contact-line flex items-center gap-2 text-ink-gray-7">
				{%= frappe.utils.icon("phone", "sm", "", "", "text-ink-gray-5", true) %}
				<a href="tel:{%= frappe.utils.escape_html(contact.phone) %}" title="{%= __("Primary Phone") %}">{%= frappe.utils.escape_html(contact.phone) %}</a>
			</div>
		{% } %}
		{% if (mobile_no) { %}
			<div class="contact-line flex items-center gap-2 text-ink-gray-7">
				{%= frappe.utils.icon("smartphone", "sm", "", "", "text-ink-gray-5", true) %}
				<a href="tel:{%= frappe.utils.escape_html(mobile_no) %}" title="{%= __("Primary Mobile") %}">{%= frappe.utils.escape_html(mobile_no) %}</a>
			</div>
		{% } %}
		{% if (contact.email_id) { %}
			<div class="contact-line flex items-center gap-2 text-ink-gray-7">
				{%= frappe.utils.icon("mail", "sm", "", "", "text-ink-gray-5", true) %}
				<a href="mailto:{%= frappe.utils.escape_html(contact.email_id) %}" title="{%= __("Primary Email") %}">{%= frappe.utils.escape_html(contact.email_id) %}</a>
			</div>
		{% } %}
		{% if (!contact.designation && !contact.phone && !mobile_no && !contact.email_id) { %}
			<div class="contact-line text-sm text-ink-gray-4">{%= __("No contact details") %}</div>
		{% } %}
	</div>
{% } %}

{% if (!contact_list.length) { %}
	{%= frappe.ui.empty_state.html({
		icon: "user",
		title: __("No contacts added yet"),
		actions: [{ label: __("New Contact"), icon: "plus", css_class: "btn-contact" }],
	}) %}
{% } %}
`;
